import { IAuthRepository, LoginCredentials } from '../../domain/repositories/auth.repository.interface';
import { IHttpClient } from '../../application/interfaces/http-client.interface';
import { Session } from '../../domain/entities/session.entity';
import { User } from '../../domain/entities/user.entity';

interface BackendLoginSuccessResponse {
  success: true;
  data: {
    accessToken: string;
    user: {
      id: string;
      email: string;
      fullName?: string | null;
      role?: string;
      permissions?: string[];
    };
  };
}

export class HttpAuthRepository implements IAuthRepository {
  constructor(private readonly httpClient: IHttpClient) {}

  public async login(credentials: LoginCredentials): Promise<Session> {
    const response = await this.httpClient.post<BackendLoginSuccessResponse>(
      '/auth/login',
      {
        email: credentials.email,
        password: credentials.password,
      }
    );

    if (!response || !response.success || !response.data) {
      throw new Error('Respuesta inválida del servidor de autenticación');
    }

    const domainUser = User.create({
      id: response.data.user.id,
      email: response.data.user.email,
      fullName: response.data.user.fullName,
      role: response.data.user.role,
      permissions: response.data.user.permissions,
    });

    return new Session({
      user: domainUser,
      token: response.data.accessToken,
    });
  }
}
